var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "design-dialog",
    attrs: {
      wrapClassName: _vm.wrapClassName,
      width: _vm.width,
      visible: _vm.visible,
      title: _vm.title,
      zIndex: _vm.zIndex,
      centered: _vm.centered,
      okText: _vm.okText,
      cancelText: _vm.cancelText,
      confirmLoading: _vm.confirmLoading,
      footer: null
    },
    on: {
      cancel: _vm.handleCancel,
      ok: _vm.handleOk
    }
  }, [_vm._t("default"), _c("template", {
    slot: "footer"
  }, [_vm._t("footer")], 2)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };